(function () {
  // Global object to expose init method
  window.SoulTheoryChat = {
    init: function (config) {
      startWidget(config);
    }
  };

  function startWidget(config) {
    const API_BASE = config.apiBase || 'https://webble.soultheory.in';
    const SHOP_URL = config.shopUrl || '';
    const DEFAULT_LAUNCHER_AVATAR = 'https://images.unsplash.com/photo-1607346256330-dee7af15f7c5?auto=format&fit=crop&w=220&h=220&q=80';
    const launcherAvatarUrl = typeof config.launcherAvatar === 'string' && config.launcherAvatar.trim()
      ? config.launcherAvatar.trim()
      : DEFAULT_LAUNCHER_AVATAR;

    // CSS Styles
    const styles = `
      :root {
        --sth-primary: #dc2626;
        --sth-primary-dark: #b91c1c;
        --sth-primary-light: #fef2f2;
        --sth-accent: #0f172a;
        --sth-bg: #ffffff;
        --sth-bg-secondary: #f8fafc;
        --sth-text: #0f172a;
        --sth-text-muted: #64748b;
        --sth-border-color: #e2e8f0;
        --sth-font: "Figtree", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        --sth-radius: 12px;
        --sth-radius-lg: 20px;
        --sth-radius-pill: 9999px;
        --sth-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
        --sth-shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        --sth-shadow-button: 0 10px 30px -10px rgba(220, 38, 38, 0.4);
      }
    
      #soultheory-chat-root {
        font-family: var(--sth-font);
        line-height: 1.5;
        -webkit-font-smoothing: antialiased;
        color: var(--sth-text);
        z-index: 2147483647;
      }
      
      #soultheory-chat-root, #soultheory-chat-root * { box-sizing: border-box; }
    
      /* Chat Button */
      /* Chat Button */
      #soultheory-chat-root .sth-chat-btn {
        position: fixed;
        bottom: max(24px, env(safe-area-inset-bottom));
        right: 24px;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        border: none;
        background: transparent;
        padding: 0;
        cursor: pointer;
        z-index: 2147483647;
        box-shadow: 0 10px 24px -6px rgba(0, 0, 0, 0.4);
        transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease;
        display: block;
        overflow: visible !important;
      }
      /* Chat Button */
      body:has(.wt-product__sticky-buy--show) #soultheory-chat-root .sth-chat-btn {
        display: none !important;
      }

      #soultheory-chat-root .sth-chat-btn:hover {
        transform: translateY(-4px) scale(1.02);
        box-shadow: 0 16px 32px -6px rgba(0, 0, 0, 0.5);
      }

      #soultheory-chat-root .sth-chat-btn:focus-visible {
        outline: 2px solid rgba(220, 38, 38, 0.6);
        outline-offset: 4px;
      }

      .sth-chat-btn-avatar {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
        border: 3px solid #ffffff;
        background-color: #cbd5e1;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        transition: transform 0.25s ease;
      }

      .sth-chat-btn-online {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #22c55e;
        border: 2.5px solid #ffffff;
        box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.15);
        transition: transform 0.25s ease, opacity 0.25s ease;
      }

      .sth-chat-btn-close-badge {
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: #171b26;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transform: scale(0.8) rotate(-90deg);
        transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
      }

      .sth-chat-btn-close-line {
        position: absolute;
        width: 3px;
        height: 24px;
        border-radius: 99px;
        background: #ffffff;
      }

      .sth-chat-btn-close-line.one {
        transform: rotate(45deg);
      }

      .sth-chat-btn-close-line.two {
        transform: rotate(-45deg);
      }

      #soultheory-chat-root .sth-chat-btn.open {
        transform: translateY(0) scale(1.05);
        box-shadow: 0 12px 28px -6px rgba(0, 0, 0, 0.4);
      }

      #soultheory-chat-root .sth-chat-btn.open .sth-chat-btn-close-badge {
        opacity: 1;
        transform: scale(1) rotate(0deg);
      }

      #soultheory-chat-root .sth-chat-btn.open .sth-chat-btn-online {
        opacity: 0;
        transform: scale(0.6);
      }

      #soultheory-chat-root .sth-chat-btn:active {
        transform: scale(0.96) translateY(0);
      }

      .sth-country-code {
        min-width: 80px;
        height: 54px;
        padding: 0 16px;
        background: #f8fafc;
        border: 1px solid var(--sth-border-color);
        border-radius: 12px;
        font-weight: 700;
        font-size: 18px;
        line-height: 1;
        color: #64748b;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        word-break: keep-all;
        position: relative;
        top: 0;
      }
    
      /* Modal */
      .sth-chat-modal {
        position: fixed;
        bottom: 100px;
        right: 24px;
        width: 400px;
        max-width: calc(100vw - 48px);
        height: 700px;
        max-height: calc(100vh - 120px);
        background: var(--sth-bg);
        border-radius: var(--sth-radius-lg);
        box-shadow: var(--sth-shadow-lg);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        z-index: 2147483646;
        opacity: 0;
        visibility: hidden;
        transform: translateY(20px) scale(0.95);
        transform-origin: bottom right;
        transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        border: 1px solid rgba(0, 0, 0, 0.05);
      }
    
      .sth-chat-modal.open {
        opacity: 1;
        visibility: visible;
        transform: translateY(0) scale(1);
      }
    
      /* Header */
      .sth-header {
        background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
        padding: 20px 24px;
        color: white;
        display: flex;
        justify-content: space-between;
        align-items: center; 
        flex-shrink: 0;
        position: relative;
        min-height: 60px;
        padding: 16px 20px;
      }
      /* Removed ::after pseudo-element for curve to save space/cleaner look */

      .sth-header-content h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        color: white;
        letter-spacing: -0.02em;
      }
    
      .sth-header-content p {
        margin: 0;
        font-size: 11px;
        color: rgba(255, 255, 255, 0.8);
        font-weight: 400;
        display: block; 
      }
    
      .sth-close-btn {
        appearance: none;
        -webkit-appearance: none;
        width: 36px !important;
        height: 36px !important;
        min-width: 36px;
        min-height: 36px;
        padding: 0 !important;
        cursor: pointer;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.14);
        border: 1px solid rgba(255, 255, 255, 0.24);
        border-radius: 999px;
        transition: background 0.2s ease, transform 0.2s ease;
        backdrop-filter: blur(4px);
        flex-shrink: 0;
        line-height: 0;
        overflow: hidden;
      }

      .sth-close-glyph {
        width: 16px;
        height: 16px;
        position: relative;
        display: block;
        transition: transform 0.2s ease;
      }

      .sth-close-glyph::before,
      .sth-close-glyph::after {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        width: 2.4px;
        height: 16px;
        margin-left: -1.2px;
        border-radius: 99px;
        background: #ffffff;
      }

      .sth-close-glyph::before { transform: rotate(45deg); }
      .sth-close-glyph::after { transform: rotate(-45deg); }

      .sth-close-btn:focus-visible {
        outline: 2px solid rgba(255, 255, 255, 0.8);
        outline-offset: 1px;
      }
    
      .sth-close-btn:hover {
        background: rgba(255, 255, 255, 0.24);
        transform: translateY(-1px);
      }

      .sth-close-btn:hover .sth-close-glyph {
        transform: rotate(90deg);
      }
    
      /* Content */
      .sth-content {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 24px;
        background: var(--sth-bg);
        position: relative;
        display: flex;
        flex-direction: column;
      }

      /* Scrollbar */
      .sth-content::-webkit-scrollbar { width: 6px; }
      .sth-content::-webkit-scrollbar-track { background: transparent; }
      .sth-content::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
      .sth-content::-webkit-scrollbar-thumb:hover { background: #cbd5e1; }
      
      /* UI Elements */
      .sth-menu-intro {
        border: 1px solid var(--sth-border-color);
        background: linear-gradient(135deg, #fff8f6 0%, #ffffff 65%);
        border-radius: 14px;
        padding: 14px 16px;
        margin-bottom: 12px;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 8px;
        min-height: 112px;
        overflow: visible;
      }
      .sth-menu-intro-top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 10px;
        position: relative;
        z-index: 1;
      }
      .sth-menu-intro-copy {
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-width: 0;
      }
      .sth-menu-symbol {
        font-size: 24px;
        color: rgba(220, 38, 38, 0.38);
        font-weight: 700;
        line-height: 1;
        margin-top: 2px;
        flex: 0 0 auto;
      }
      .sth-menu-kicker {
        display: inline-flex;
        align-items: center;
        line-height: 1.2;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        color: var(--sth-primary);
        font-weight: 700;
        margin-top: 3px;
      }
      .sth-menu-title {
        margin: 0;
        font-size: 21px;
        font-weight: 700;
        color: var(--sth-text);
        line-height: 1.2;
        letter-spacing: -0.02em;
        position: relative;
        z-index: 1;
      }
      .sth-menu-subtitle {
        margin: 0 0 2px;
        color: var(--sth-text-muted);
        font-size: 14px;
        line-height: 1.25;
        position: relative;
        z-index: 1;
      }
      .sth-menu-logout {
        appearance: none;
        -webkit-appearance: none;
        border: none;
        border-radius: 0;
        color: var(--sth-text-muted);
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        padding: 6px 0 2px;
        min-height: 0;
        width: auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        line-height: 1.1;
        letter-spacing: 0.04em;
        font-family: inherit;
        background: transparent;
        transition: all 0.2s;
        margin: 2px auto 0;
        text-transform: uppercase;
      }
      .sth-menu-logout:hover {
        color: var(--sth-primary);
        text-decoration: underline;
        text-underline-offset: 3px;
      }
      .sth-menu-logout svg {
        width: 14px;
        height: 14px;
        stroke: currentColor;
        fill: none;
      }
      .sth-menu-logout:focus-visible {
        outline: none;
        box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.2);
        border-radius: 6px;
      }
      .sth-menu-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 0 calc(8px + env(safe-area-inset-bottom));
      }
      .sth-menu {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        margin-bottom: 12px;
      }
      .sth-menu-item { 
        background: white; 
        border: 1px solid var(--sth-border-color); 
        border-radius: 12px; 
        padding: 20px 12px; 
        text-align: center; 
        cursor: pointer; 
        transition: all 0.2s ease; 
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.02);
      }
      .sth-menu-item:hover { 
        border-color: var(--sth-primary); 
        transform: translateY(-2px); 
        box-shadow: 0 4px 12px rgba(220, 38, 38, 0.1); 
      }
      .sth-menu-item .icon { font-size: 24px; display: block; margin-bottom: 4px; }
      .sth-menu-item .label { font-size: 13px; font-weight: 600; color: var(--sth-text); line-height: 1.3; }
    
      .sth-form-embedded { 
        background: var(--sth-bg-secondary); 
        padding: 20px; 
        border-radius: 16px; 
        border: 1px solid transparent; 
        margin-top: 16px;
      }
      
      .sth-input-group { margin-bottom: 16px; text-align: left; }
      .sth-label { display: block; font-size: 13px; font-weight: 600; margin-bottom: 6px; color: var(--sth-text); }
      .sth-label.required::after { content: "*"; color: var(--sth-primary); margin-left: 2px; }

      .sth-input, .sth-textarea { 
        width: 100%; 
        padding: 14px 16px; 
        border: 1px solid var(--sth-border-color); /* Slight border for clarity */
        border-radius: 12px; 
        font-size: 15px; 
        font-family: inherit; 
        color: var(--sth-text); 
        outline: none; 
        transition: all 0.2s; 
        box-sizing: border-box; 
        background: white; 
        box-shadow: 0 1px 2px rgba(0,0,0,0.02);
      }
      .sth-input:focus, .sth-textarea:focus { 
        border-color: var(--sth-primary); 
        box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.1); 
      }
      .sth-textarea { min-height: 100px; resize: vertical; }

      .sth-btn { 
        width: 100%; 
        padding: 16px; 
        background: var(--sth-accent); 
        color: white; 
        border: none; 
        border-radius: var(--sth-radius-pill); 
        font-size: 15px; 
        font-weight: 600; 
        cursor: pointer; 
        transition: all 0.2s; 
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);    
      }
      .sth-btn:hover { 
        background: #000; 
        transform: translateY(-2px); 
        box-shadow: 0 8px 16px rgba(0,0,0,0.15); 
      }
      .sth-btn:active { transform: translateY(0); }
      .sth-btn:disabled { background: #cbd5e1; cursor: not-allowed; transform: none; box-shadow: none; }
      
      .sth-message { 
        padding: 16px 20px; 
        border-radius: 16px; 
        margin-bottom: 16px; 
        font-size: 15px;
        line-height: 1.6;
        animation: sth-fade-in 0.3s ease-out backwards;
      }
      .sth-message.bot { 
        background: white; 
        border: 1px solid var(--sth-border-color);
        border-bottom-left-radius: 4px; 
        box-shadow: 0 2px 4px rgba(0,0,0,0.02);
        color: var(--sth-text);
      }
      
      .sth-ticket-card { 
        background: white; 
        border: 1px solid var(--sth-border-color); 
        border-radius: 16px; 
        padding: 16px; 
        margin-bottom: 8px; 
        cursor: pointer; 
        transition: all 0.2s; 
        position: relative;
        overflow: hidden;
      }
      .sth-ticket-card::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: var(--sth-border-color);
        transition: background 0.2s;
      }
      .sth-ticket-card:hover { 
        transform: translateY(-2px); 
        box-shadow: 0 8px 16px -4px rgba(0,0,0,0.05);
        border-color: #cbd5e1;
      }
      .sth-ticket-card:hover::before {
        background: var(--sth-primary);
      }
    
      .sth-back { 
        padding: 16px 24px; 
        font-size: 14px; 
        font-weight: 600; 
        color: var(--sth-text-muted); 
        background: transparent; 
        cursor: pointer; 
        display: flex; 
        align-items: center; 
        gap: 8px; 
        transition: color 0.2s; 
        border-bottom: 1px solid transparent;
      }
      .sth-back svg { width: 16px; height: 16px; stroke-width: 2.5; }
      .sth-back:hover { color: var(--sth-primary); }
    
      .sth-issue-btn { 
        width: 100%; 
        padding: 18px 20px; 
        border: 1px solid var(--sth-border-color); 
        border-radius: 12px; 
        background: white; 
        text-align: left; 
        margin-bottom: 10px; 
        font-weight: 600; 
        cursor: pointer; 
        transition: all 0.2s; 
        display: flex; 
        justify-content: space-between; 
        align-items: center; 
        color: var(--sth-text); 
      }
      .sth-issue-btn:hover { border-color: var(--sth-primary); background: var(--sth-primary-light); color: var(--sth-primary); }
      .sth-issue-btn .arrow { transition: transform 0.2s; }
      .sth-issue-btn:hover .arrow { transform: translateX(4px); }

      .sth-product-select-card { 
        padding: 16px; 
        border: 1px solid var(--sth-border-color); 
        border-radius: 12px; 
        margin-bottom: 10px; 
        display: flex; 
        align-items: center; 
        gap: 16px; 
        cursor: pointer; 
        transition: all 0.2s; 
        background: white; 
      }
      .sth-product-select-card:hover { border-color: #cbd5e1; }
      .sth-product-select-card.selected { border-color: var(--sth-primary); background: var(--sth-primary-light); }
      
      .sth-checkbox { 
        width: 24px; 
        height: 24px; 
        border: 2px solid #cbd5e1; 
        border-radius: 6px; 
        display: flex; 
        align-items: center; 
        justify-content: center; 
        color: white; 
        font-size: 14px; 
        transition: all 0.2s;
        background: white;
      }
      .sth-product-select-card.selected .sth-checkbox { 
        background: var(--sth-primary); 
        border-color: var(--sth-primary); 
        transform: scale(1.1);
      }
    
      /* FAQ */
      .sth-faq-item { 
        background: white; 
        border-radius: 12px; 
        margin-bottom: 12px; 
        border: 1px solid var(--sth-border-color);
        overflow: hidden; 
        transition: all 0.3s ease; 
      }
      .sth-faq-item:hover { border-color: #cbd5e1; }
      .sth-faq-question { 
        padding: 18px; 
        font-weight: 600; 
        font-size: 15px; 
        color: var(--sth-text); 
        cursor: pointer; 
        display: flex; 
        justify-content: space-between; 
        align-items: center; 
      }
      .sth-faq-answer { 
        max-height: 0; 
        overflow: hidden; 
        transition: max-height 0.3s cubic-bezier(0, 1, 0, 1); 
        background: var(--sth-bg-secondary); 
        color: var(--sth-text-muted); 
        font-size: 14px; 
        line-height: 1.6; 
      }
      .sth-faq-item.active .sth-faq-answer { 
        max-height: 300px; /* Safe upper limit */
        padding: 18px; 
        border-top: 1px solid var(--sth-border-color); 
      }
      .sth-faq-item.active .sth-faq-question { color: var(--sth-primary); }
      .sth-faq-item.active .toggle { transform: rotate(45deg); color: var(--sth-primary); }
    
      /* Upload */
      .sth-file-upload { 
        border: 2px dashed #cbd5e1; 
        background: var(--sth-bg-secondary); 
        border-radius: 12px; 
        padding: 24px; 
        text-align: center; 
        cursor: pointer; 
        display: flex; 
        flex-direction: column;
        align-items: center; 
        gap: 8px; 
        transition: all 0.2s; 
      }
      .sth-file-upload:hover { border-color: var(--sth-primary); background: var(--sth-primary-light); }
      
      .sth-file-preview { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
      .sth-file-preview-item { 
        width: 64px; 
        height: 64px; 
        border-radius: 8px; 
        overflow: hidden; 
        border: 1px solid var(--sth-border-color); 
        position: relative; 
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
      }
      .sth-file-preview-item img { width: 100%; height: 100%; object-fit: cover; }
      .sth-file-remove { 
        position: absolute; 
        top: 2px; 
        right: 2px; 
        width: 20px; 
        height: 20px; 
        background: rgba(0,0,0,0.7); 
        color: white; 
        border: none; 
        border-radius: 50%; 
        display: flex; 
        align-items: center; 
        justify-content: center; 
        font-size: 12px; 
        cursor: pointer; 
        transition: transform 0.2s;
      }
      .sth-file-remove:hover { transform: scale(1.1); background: var(--sth-primary); }
      
      @keyframes sth-fade-in { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
      @keyframes sth-chat-pulse {
        0% { transform: scale(0.85); opacity: 0.8; }
        70% { transform: scale(1.05); opacity: 0; }
        100% { transform: scale(1.12); opacity: 0; }
      }
      @keyframes spin { 100% { transform: rotate(360deg); } }
    
      @media (max-width: 480px) {
        .sth-chat-modal { bottom: 0; right: 0; left: 0; width: 100%; max-width: none; height: 100%; border-radius: 0; }
        .sth-chat-btn {
          bottom: max(14px, env(safe-area-inset-bottom));
          right: 14px;
          width: 48px;
          height: 48px;
        }
        .sth-menu-intro { padding: 12px; min-height: 102px; }
        .sth-menu-title { font-size: 18px; }
        .sth-menu-subtitle { font-size: 13px; }
        .sth-menu-symbol { font-size: 20px; }
        .sth-header { padding-top: max(20px, env(safe-area-inset-top)); border-radius: 0; }
      }
    `;

    // Inject CSS once
    const styleId = 'soultheory-chat-widget-style';
    let styleSheet = document.getElementById(styleId);
    if (!styleSheet) {
      styleSheet = document.createElement("style");
      styleSheet.id = styleId;
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
    } else if (styleSheet.innerText !== styles) {
      styleSheet.innerText = styles;
    }

    // Initial State
    let state = {
      isOpen: false,
      view: 'login',
      phone: '',
      user: null,
      tickets: [],
      selectedTicket: null,
      orders: [],
      selectedOrder: null,
      selectedIssue: null,
      selectedProducts: [],
      loading: false,
      ordersLoading: false,
      error: '',
      ticketType: 'other',
      successMessage: '',
      files: [],
      otp: '',
      ordersFetchedAt: 0
    };

    // --- Core Logic & API Functions ---

    const ORDER_CACHE_TTL_MS = 180000;

    function hasFreshOrders() {
      return state.ordersFetchedAt > 0 && (Date.now() - state.ordersFetchedAt < ORDER_CACHE_TTL_MS);
    }

    async function fetchOrdersByPhone(force) {
      if (!state.phone) return [];
      if (!force && hasFreshOrders()) return state.orders;
      const res = await fetch(API_BASE + '/api/orders/by-phone/' + state.phone);
      const data = await res.json();
      state.orders = data.orders || [];
      state.ordersFetchedAt = Date.now();
      const updatedFromCustomer = syncFirstNameFromCustomerProfile(data.customer || data.user || data.profile || null);
      const updatedFromOrders = syncFirstNameFromOrders(state.orders);
      if ((updatedFromCustomer || updatedFromOrders) && state.view === 'menu') render();
      return state.orders;
    }

    function prefetchOrders(force) {
      fetchOrdersByPhone(force).catch(() => { });
    }

    function loadState() {
      try {
        const saved = localStorage.getItem('sth_chat_state');
        if (saved) {
          const parsed = JSON.parse(saved);
          if (parsed.user) {
            // Preserve runtime fields (for example Shopify-provided first name).
            state.user = { ...parsed.user, ...state.user };
            const persistedId = String(state.user.id || '').trim();
            if (persistedId && !looksLikeBackendUserId(persistedId)) {
              // Older builds sometimes persisted Shopify customer ID here.
              delete state.user.id;
            }
            state.phone = state.user.phone || parsed.user.phone || state.phone;
            const savedShopifyFirstName = extractFirstName(state.user.shopifyFirstName || state.user.shopify_first_name);
            if (!savedShopifyFirstName) {
              state.user.shopifyFirstName = '';
              state.user.shopify_first_name = '';
              state.user.firstName = '';
              state.user.first_name = '';
              if (state.user.nameSource !== 'shopify') state.user.name = '';
            } else {
              state.user.shopifyFirstName = savedShopifyFirstName;
              state.user.shopify_first_name = savedShopifyFirstName;
              state.user.firstName = savedShopifyFirstName;
              state.user.first_name = savedShopifyFirstName;
              state.user.name = savedShopifyFirstName;
              state.user.nameSource = 'shopify';
            }
            state.view = 'menu';
          }
        }
      } catch (e) { }
    }

    function saveState() {
      try { localStorage.setItem('sth_chat_state', JSON.stringify({ user: state.user })); } catch (e) { }
    }

    function looksLikeBackendUserId(value) {
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(value || '').trim());
    }

    function extractFirstName(value) {
      if (typeof value !== 'string') return '';
      const cleaned = value.trim().replace(/\s+/g, ' ');
      if (!cleaned) return '';

      const firstChunk = cleaned.split(' ')[0];
      const chunk = firstChunk.includes('@') ? firstChunk.split('@')[0] : firstChunk;
      const normalized = chunk.replace(/^[^a-zA-Z'-]+|[^a-zA-Z'-]+$/g, '');
      if (!normalized) return '';
      if (!/[a-zA-Z]/.test(normalized)) return '';
      if (/[0-9@]/.test(normalized)) return '';

      if (/^(friend|guest|customer|user|null|unknown|na)$/i.test(normalized)) return '';
      return normalized.charAt(0).toUpperCase() + normalized.slice(1);
    }

    function getCurrentShopifyFirstName() {
      const current = extractFirstName(
        state.user?.shopifyFirstName ||
        state.user?.shopify_first_name ||
        (state.user?.nameSource === 'shopify' ? (state.user?.firstName || state.user?.first_name || state.user?.name) : '')
      );
      return current;
    }

    function getDisplayFirstName() {
      const candidates = [
        config?.user?.firstName,
        config?.user?.first_name,
        config?.user?.name,
        state.user?.shopifyFirstName,
        state.user?.shopify_first_name,
        state.user?.nameSource === 'shopify' ? state.user?.firstName : '',
        state.user?.nameSource === 'shopify' ? state.user?.first_name : '',
        state.user?.nameSource === 'shopify' ? state.user?.name : ''
      ];

      for (let i = 0; i < candidates.length; i += 1) {
        const first = extractFirstName(candidates[i]);
        if (first) return first;
      }

      return 'Friend';
    }

    function getNormalizedPhone(value) {
      const digits = String(value || '').replace(/\D/g, '');
      if (!digits) return '';
      if (digits.length > 10) return digits.slice(-10);
      return digits;
    }

    function getTicketAuthQuery() {
      const params = new URLSearchParams();
      const backendUserId = looksLikeBackendUserId(state.user?.id) ? String(state.user.id).trim() : '';
      const phone = getNormalizedPhone(state.user?.phone || state.phone);

      if (backendUserId) params.set('userId', backendUserId);
      if (phone) params.set('phone', phone);

      const query = params.toString();
      return query ? `?${query}` : '';
    }

    function syncFirstNameFromOrders(orders) {
      if (!orders || !orders.length) return false;

      const current = getCurrentShopifyFirstName();
      if (current) return false;

      let derived = '';
      for (let i = 0; i < orders.length; i += 1) {
        const order = orders[i] || {};
        const candidates = [
          order.customerFirstName,
          order.customer_first_name,
          order.firstName,
          order.customerName,
          order.customer_name,
          order.customer && order.customer.firstName,
          order.customer && order.customer.first_name,
          order.customer && order.customer.name,
          order.shippingAddress && order.shippingAddress.firstName,
          order.shippingAddress && order.shippingAddress.first_name,
          order.shipping_address && order.shipping_address.first_name,
          order.billingAddress && order.billingAddress.firstName,
          order.billingAddress && order.billingAddress.first_name
        ];

        for (let j = 0; j < candidates.length; j += 1) {
          const first = extractFirstName(candidates[j]);
          if (first) {
            derived = first;
            break;
          }
        }
        if (derived) break;
      }

      if (!derived) return false;

      state.user = {
        ...(state.user || {}),
        shopifyFirstName: derived,
        shopify_first_name: derived,
        firstName: derived,
        first_name: derived,
        name: derived,
        nameSource: 'shopify'
      };
      saveState();
      return true;
    }

    function syncFirstNameFromCustomerProfile(profile) {
      if (!profile || typeof profile !== 'object') return false;

      const current = getCurrentShopifyFirstName();
      const first = extractFirstName(
        profile.firstName ||
        profile.first_name ||
        profile.givenName ||
        profile.given_name ||
        profile.name ||
        profile.fullName ||
        profile.full_name
      );
      if (!first) return false;
      if (current && current.toLowerCase() === first.toLowerCase()) return false;

      const lastName = typeof profile.lastName === 'string' ? profile.lastName.trim() : '';
      state.user = {
        ...(state.user || {}),
        shopifyFirstName: first,
        shopify_first_name: first,
        firstName: first,
        first_name: first,
        name: lastName ? `${first} ${lastName}` : first,
        nameSource: 'shopify'
      };
      saveState();
      return true;
    }

    function syncFirstNameFromTickets(tickets) {
      return false;
    }

    const getStatusBadge = (status) => {
      if (!status) return { bg: '#f3f4f6', color: '#6b7280', text: 'Unknown' };
      const s = status.toUpperCase();
      const badges = {
        'FULFILLED': { bg: '#dcfce7', color: '#16a34a', text: 'Delivered' },
        'DELIVERED': { bg: '#dcfce7', color: '#16a34a', text: 'Delivered' },
        'IN_TRANSIT': { bg: '#fef3c7', color: '#d97706', text: 'In Transit' },
        'UNFULFILLED': { bg: '#f3f4f6', color: '#6b7280', text: 'Processing' },
        'CANCELLED': { bg: '#fee2e2', color: '#dc2626', text: 'Cancelled' }
      };
      return badges[s] || { bg: '#f3f4f6', color: '#6b7280', text: status };
    };

    const formatDate = (dateStr) => {
      try { return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return dateStr; }
    };

    // --- Render Functions ---

    function render() {
      let root = document.getElementById('soultheory-chat-root');
      if (!root) {
        root = document.createElement('div');
        root.id = 'soultheory-chat-root';
        document.body.appendChild(root);
      }

      let content = '';
      switch (state.view) {
        case 'login': content = renderLogin(); break;
        case 'verify': content = renderVerify(); break;
        case 'menu': content = renderMenu(); break;
        case 'orders': content = renderOrders(); break;
        case 'select-order': content = renderSelectOrder(); break;
        case 'select-issue': content = renderSelectIssue(); break;
        case 'select-products': content = renderSelectProducts(); break;
        case 'order-detail': content = renderOrderDetail(); break;
        case 'product-help': content = renderProductHelp(); break;
        case 'create-ticket': content = renderCreateTicket(); break;
        case 'my-tickets': content = renderMyTickets(); break;
        case 'ticket-detail': content = renderTicketDetail(); break;
        case 'success': content = renderSuccess(); break;
      }

      root.innerHTML = `
        <button class="sth-chat-btn ${state.isOpen ? 'open' : ''}" onclick="window.sthToggleChat()" aria-label="${state.isOpen ? 'Close support chat' : 'Open support chat'}">
          <span class="sth-chat-btn-avatar" style="background-image:url('${launcherAvatarUrl}');"></span>
          <span class="sth-chat-btn-online" aria-hidden="true"></span>
          <span class="sth-chat-btn-close-badge" aria-hidden="true">
            <span class="sth-chat-btn-close-line one"></span>
            <span class="sth-chat-btn-close-line two"></span>
          </span>
        </button>
        <div class="sth-chat-modal ${state.isOpen ? 'open' : ''}">
          <div class="sth-header">
            <div class="sth-header-content">
              <div style="display:flex; align-items:center; gap:12px;">
                 <img src="${API_BASE}/assets/logo-om-white.jpg" style="width:36px; height:36px; border-radius:50%; object-fit:cover; mix-blend-mode:screen;" alt="ST">
                 <h3 style="margin:0; font-size:16px; font-weight:700; color:white;">Soultheory Support</h3>
              </div>
            </div>
            <button class="sth-close-btn" onclick="window.sthToggleChat()" aria-label="Close support chat" title="Close">
              <span class="sth-close-glyph" aria-hidden="true"></span>
            </button>
          </div>
          ${content}
        </div>
      `;
    }

    function renderLogin() {
      return `
        <div class="sth-content" style="display:flex; flex-direction:column; justify-content:flex-start; align-items:center; text-align:center; padding-top:24px;">
          <div style="margin-bottom:18px; position:relative;">
             <img src="${API_BASE}/assets/logo-horizontal-red-clean.png" style="width:176px; display:block;" alt="Soultheory">
          </div>
          <h2 style="margin:0 0 12px; font-size: 20px; font-weight:800; color: var(--sth-text); letter-spacing:-0.02em;">Welcome Back</h2>
          <p style="margin:0 0 28px; color:var(--sth-text-muted); font-size:15px; line-height:1.55; max-width:320px;">
            Login to track your authentic spiritual essentials orders and get support.
          </p>
          <div class="sth-form-embedded" style="width:100%; padding:22px; border:1px solid var(--sth-border-color); box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02); background:white;">
               ${state.error ? `<div style="background:#fef2f2; color:#b91c1c; padding:12px; border-radius:8px; font-size:13px; margin-bottom:16px; display:flex; align-items:center; gap:8px;"><span style="font-size:16px">⚠️</span> ${state.error}</div>` : ''}
               <div style="display:flex; gap:12px; margin-bottom:18px; align-items:center;">
                  <span class="sth-country-code">+91</span>
                  <input type="tel" class="sth-input" id="sth-phone" placeholder="Mobile Number" value="${state.phone}" maxlength="10" style="height:54px;" />
               </div>
               <button class="sth-btn" onclick="window.sthSendOTP()" ${state.loading ? 'disabled' : ''}>
                  ${state.loading ? 'Sending OTP...' : 'Continue with Phone'}
               </button>
          </div>
        </div>
      `;
    }

    function renderVerify() {
      return `
        <div class="sth-back" onclick="window.sthGoTo('login')">
           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
           Change Number
        </div>
        <div class="sth-content" style="text-align:center;">
           <div style="margin:20px 0;">
              <div style="width:64px; height:64px; background:#f0f9ff; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; color:#0284c7;">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
              </div>
           </div>
           <h3 style="margin:0 0 8px; font-size:20px; font-weight:700;">Verify it's you</h3>
           <p style="margin:0 0 32px; color:var(--sth-text-muted);">We've sent a code to <strong>${state.phone}</strong></p>
           
           <div class="sth-form-embedded" style="background:white; border:1px solid var(--sth-border-color); box-shadow:0 4px 12px rgba(0,0,0,0.03);">
               ${state.error ? `<div style="background:#fef2f2; color:#b91c1c; padding:12px; border-radius:8px; font-size:13px; margin-bottom:16px;">${state.error}</div>` : ''}
               <div class="sth-input-group" style="text-align:center;">
                  <input type="text" class="sth-input" id="sth-otp" placeholder="0000" maxlength="4" value="${state.otp || ''}" style="text-align: center; letter-spacing: 12px; font-size: 32px; padding: 20px; font-weight:700; border-radius:16px; background:#f8fafc;" />
               </div>
               <button class="sth-btn" onclick="window.sthVerifyOTP()" ${state.loading ? 'disabled' : ''}>
                  ${state.loading ? 'Verifying...' : 'Verify & Login'}
               </button>
           </div>
           <p style="margin-top:24px; font-size:13px; color:var(--sth-text-muted); cursor:pointer;" onclick="window.sthSendOTP()">Resend Code</p>
        </div>
      `;
    }

    function renderMenu() {
      const userName = getDisplayFirstName();
      const welcomeText = `Welcome back, <span style="color: var(--sth-primary);">${userName}</span>`;

      return `
        <div class="sth-content" style="padding: 20px; display: flex; flex-direction: column;">
           <div class="sth-menu-intro">
             <div class="sth-menu-intro-top">
               <div class="sth-menu-intro-copy">
                 <span class="sth-menu-kicker">Soultheory Support</span>
                 <h2 class="sth-menu-title">${welcomeText}</h2>
                 <p class="sth-menu-subtitle">How can we support your journey today?</p>
               </div>
               <span class="sth-menu-symbol" aria-hidden="true">ॐ</span>
             </div>
           </div>
           
           <div class="sth-menu">
             <div class="sth-menu-item" onclick="window.sthLoadOrders()">
               <div class="icon">📦</div>
               <div class="label">Track Order</div>
             </div>
             <div class="sth-menu-item" onclick="window.sthStartIssueFlow()">
               <div class="icon">⚠️</div>
               <div class="label">Report Issue</div>
             </div>
             <div class="sth-menu-item" onclick="window.sthGoTo('product-help')">
               <div class="icon">🔮</div>
               <div class="label">Product FAQs</div>
             </div>
             <div class="sth-menu-item" onclick="window.sthLoadTickets(); window.sthGoTo('my-tickets')">
               <div class="icon">📋</div>
               <div class="label">My Tickets</div>
             </div>
             <!-- Full width item -->
             <div class="sth-menu-item" onclick="window.sthGoTo('create-ticket', 'other')" style="grid-column: span 2; flex-direction: row; justify-content: center; padding: 16px;">
               <div class="icon" style="font-size: 20px; margin: 0; margin-right: 8px;">💬</div>
               <div class="label" style="font-size: 14px;">Help with something else</div>
             </div>
           </div>
           <div class="sth-menu-footer">
             <button class="sth-menu-logout" onclick="window.sthLogout()">
               <svg viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                 <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                 <polyline points="16 17 21 12 16 7"></polyline>
                 <line x1="21" y1="12" x2="9" y2="12"></line>
               </svg>
               Log out
             </button>
           </div>
        </div>
      `;
    }

    function renderOrders() {
      if (state.loading) return `<div class="sth-back" onclick="window.sthGoTo('menu')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Menu</div><div class="sth-content"><div style="text-align:center;padding:40px; color:#94a3b8;"><span style="display:inline-block; animation:spin 1s linear infinite; margin-bottom:8px;">⏳</span><br>Fetching orders...</div></div>`;
      let ordersHtml = '';
      if (state.orders.length === 0) {
        ordersHtml = `<div style="text-align:center; padding: 60px 20px; color:#94a3b8;"><div style="font-size:48px; margin-bottom:16px; opacity:0.6;">📭</div><p style="font-size:15px; margin-bottom:16px;">No orders found linked to this number.</p><button class="sth-btn" onclick="window.sthGoTo('menu')" style="width:auto; padding:10px 24px; font-size:13px;">Return to Menu</button></div>`;
      } else {
        ordersHtml = state.orders.map(o => {
          const badge = getStatusBadge(o.deliveryStatus || o.displayFulfillmentStatus);
          return `
           <div class="sth-ticket-card" style="display:flex; flex-direction:column; gap:12px; border-left:4px solid ${badge.color};">
              <div style="display:flex; justify-content:space-between; align-items:flex-start; cursor:pointer;" onclick="window.sthSelectOrder('${o.orderNumber}')">
                 <div>
                    <div style="font-weight:700; font-size:15px; color:var(--sth-text);">${o.orderNumber}</div>
                    <div style="font-size:12px; color:#94a3b8; margin-top:2px;">${formatDate(o.createdAt || o.date)}</div>
                 </div>
                 <div style="text-align:right;">
                    <div style="font-weight:700; color:var(--sth-primary);">${o.totalPrice || o.amount}</div>
                    <span style="font-size:10px; background:${badge.bg}; color:${badge.color}; padding:3px 8px; border-radius:12px; font-weight:700; text-transform:uppercase; display:inline-block; margin-top:4px;">${badge.text}</span>
                 </div>
              </div>
              ${o.trackingUrl ? `<a href="${o.trackingUrl}" target="_blank" style="display:flex; align-items:center; justify-content:center; gap:6px; padding:12px; background:#f8fafc; color:var(--sth-text); border:1px solid #e2e8f0; border-radius:8px; font-size:13px; font-weight:600; text-decoration:none; transition:all 0.2s;" onmouseover="this.style.background='#f1f5f9'" onmouseout="this.style.background='#f8fafc'">🚚 Track Shipment</a>` : ''}
           </div>
         `;
        }).join('');
      }
      return `<div class="sth-back" onclick="window.sthGoTo('menu')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Menu</div><div class="sth-content"><div class="sth-message bot"><p>Here are your recent orders:</p></div>${ordersHtml}</div>`;
    }

    function renderSelectOrder() {
      if (state.loading || state.ordersLoading) return `<div class="sth-back" onclick="window.sthGoTo('menu')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Menu</div><div class="sth-content">Loading...</div>`;
      const orders = state.orders || [];
      let listHtml = orders.length === 0 ? `<div style="text-align:center; padding:40px; color:#94a3b8;">No orders found.</div>` : orders.map(o => {
        const badge = getStatusBadge(o.deliveryStatus || o.displayFulfillmentStatus);
        return `<div class="sth-ticket-card" onclick="window.sthSelectOrderForIssue('${o.orderNumber}')" style="display:flex; justify-content:space-between; align-items:center;"><div><div style="font-weight:700; color:var(--sth-text);">${o.orderNumber}</div><div style="font-size:12px; color:#94a3b8;">${formatDate(o.createdAt || o.date)}</div></div><span style="font-size:10px; padding:3px 8px; border-radius:12px; background:${badge.bg}; color:${badge.color}; font-weight:700; text-transform:uppercase;">${badge.text}</span></div>`;
      }).join('');
      return `<div class="sth-back" onclick="window.sthGoTo('menu')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Menu</div><div class="sth-content"><div class="sth-message bot"><p>Select an order to report an issue with:</p></div>${state.error ? `<div style="color:#ef4444; background:#fef2f2; padding:12px; border-radius:8px; font-size:13px; margin-bottom:12px; display:flex; align-items:center; gap:8px;">⚠️ ${state.error}</div>` : ''}${listHtml}<div style="text-align:center; margin-top:24px;"><button class="sth-btn" style="background:transparent; color:var(--sth-text-muted); border:1px solid var(--sth-border-color); box-shadow:none;" onclick="window.sthGoTo('create-ticket', 'other')">Can't find order?</button></div></div>`;
    }

    function renderSelectIssue() {
      const issues = [{ id: 'damaged', label: 'Item Damaged / Defective' }, { id: 'missing', label: 'Item Missing' }, { id: 'wrong', label: 'Wrong Item Received' }, { id: 'other', label: 'Other Issue' }];
      return `<div class="sth-back" onclick="window.sthStartIssueFlow()"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Select Order</div><div class="sth-content"><div class="sth-message bot"><p>What issue are you facing with Order <strong>${state.selectedOrder?.orderNumber}</strong>?</p></div>${issues.map(i => `<div class="sth-issue-btn" onclick="window.sthSelectIssue('${i.id}')"><span>${i.label}</span><svg class="arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></div>`).join('')}</div>`;
    }

    function renderSelectProducts() {
      const items = state.selectedOrder?.lineItems || [];
      const itemsHtml = items.map((item, idx) => {
        const isSelected = state.selectedProducts.some(p => p.id === item.id);
        const imgContent = item.image ? `<img src="${item.image}" style="width:100%; height:100%; object-fit:cover;">` : `<div style="width:100%; height:100%; background:#f1f5f9; display:flex; align-items:center; justify-content:center; color:#cbd5e1; font-size:10px;">No Img</div>`;
        return `<div class="sth-product-select-card ${isSelected ? 'selected' : ''}" onclick="window.sthToggleProduct(${idx})"><div class="sth-checkbox">${isSelected ? '✓' : ''}</div><div style="width:48px; height:48px; border-radius:8px; overflow:hidden; background:#f8fafc; flex-shrink:0; border:1px solid #e2e8f0;">${imgContent}</div><div style="flex:1;"><div style="font-size:14px; font-weight:600; color:var(--sth-text);">${item.title || item.name}</div><div style="font-size:12px; color:#94a3b8;">Qty: ${item.quantity}</div></div></div>`;
      }).join('');
      return `<div class="sth-back" onclick="window.sthGoTo('select-issue')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Select Issue Type</div><div class="sth-content"><div class="sth-message bot"><p>Select the affected products:</p></div>${state.error ? `<div style="color:#ef4444; margin-bottom:12px; font-size:13px; background:#fef2f2; padding:8px 12px; border-radius:8px;">${state.error}</div>` : ''}${itemsHtml}<div style="height:16px;"></div><button class="sth-btn" onclick="window.sthSubmitIssue()" style="background:var(--sth-primary);">Confirm Selection</button></div>`;
    }

    function renderOrderDetail() {
      const o = state.selectedOrder; if (!o) return renderOrders();
      const badge = getStatusBadge(o.deliveryStatus || o.displayFulfillmentStatus);
      return `<div class="sth-back" onclick="window.sthGoTo('orders')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Your Orders</div><div class="sth-content"><div style="background:white; border:1px solid var(--sth-border-color); border-radius:16px; padding:20px; margin-bottom:16px; box-shadow:0 4px 6px -1px rgba(0,0,0,0.02);"><h3 style="margin:0 0 16px; font-size:18px; color:var(--sth-text);">${o.orderNumber}</h3><div style="display:flex; justify-content:space-between; margin-bottom:8px; font-size:14px;"><span style="color:var(--sth-text-muted)">Status</span><span style="font-weight:600; color:${badge.color};">${badge.text}</span></div><div style="display:flex; justify-content:space-between; font-size:14px;"><span style="color:var(--sth-text-muted)">Total</span><span style="font-weight:600; color:var(--sth-primary);">${o.totalPrice || o.amount}</span></div><div style="margin-top:20px; display:flex; gap:10px;">${o.trackingUrl ? `<a href="${o.trackingUrl}" target="_blank" class="sth-btn" style="text-decoration:none; text-align:center; font-size:13px; padding:12px; border-radius:12px; box-shadow:none;">Track Package</a>` : ''}</div><div style="margin-top:24px; padding-top:20px; border-top:1px solid #f1f5f9;"><h4 style="margin:0 0 16px; font-size:12px; text-transform:uppercase; color:#94a3b8; letter-spacing:0.5px; font-weight:700;">Items</h4>${o.lineItems.map(i => `<div style="display:flex; gap:12px; margin-bottom:12px; align-items:center;"><div style="width:48px; height:48px; background:#f8fafc; border:1px solid #e2e8f0; border-radius:8px; overflow:hidden; display:flex; align-items:center; justify-content:center;">${i.image ? `<img src="${i.image}" style="width:100%; height:100%; object-fit:cover;">` : '<span style="color:#cbd5e1; font-size:16px;">📦</span>'}</div><div style="flex:1;"><div style="font-size:14px; font-weight:600; color:var(--sth-text);">${i.title || i.name}</div><div style="font-size:12px; color:#94a3b8;">Qty: ${i.quantity}</div></div></div>`).join('')}</div></div><div style="text-align:center;"><span style="font-size:13px; color:var(--sth-text-muted);">Need help with this order?</span><br><span style="font-size:13px; font-weight:600; color:var(--sth-primary); cursor:pointer; text-decoration:none;" onclick="window.sthSelectOrderForIssue('${o.orderNumber}')">Report an Issue →</span></div></div>`;
    }

    function renderProductHelp() {
      const faqs = {
        '💎 Product & Authenticity': [
          { q: 'Are Soultheory products authentic and natural?', a: 'Yes, we source genuine materials and quality-check each piece. All our crystals are 100% natural. We source directly from trusted mines and each stone is inspected.' },
          {
            q: 'How do I choose the right product for my purpose?', a: 'You can message or raise a ticket with us with your goal (love, protection, focus, prosperity, etc.) and we\'ll recommend the best options.'
          },
          { q: 'Will the plating last?', a: 'Our gold/silver plating is high quality. Follow care instructions for long-lasting shine.' }
        ],
        '📦 Orders & Shipping': [
          { q: 'How long does shipping take?', a: 'Orders usually ship with Standard delivery 3-5 working days. Express (chargeable) is 1-3 days.' },
          {
            q: 'How can I track my order?', a: 'You\'ll receive a tracking link once your order ships.You can also track it in our Track Order section.'
          },
          { q: 'Can I change my shipping address after placing an order?', a: 'Address changes are possible only before shipment. Contact us immediately for help.' },
          { q: 'Can I cancel my order?', a: 'You can request a cancellation before shipment. No cancellation is possible after the order is shipped.' }
        ],
        '💳 Payments': [
          { q: 'What payment methods do you accept?', a: 'We accept major cards, UPI, wallets, and other standard payment options at checkout.' },
          { q: 'Is COD available?', a: 'COD availability depends on your PIN code and may require phone/address verification before dispatch.' }
        ],
        '🔄 Returns & Support': [
          { q: 'What is your return policy?', a: 'We offer easy returns and replacement. Check our Returns Policy page for full details.' },
          {
            q: 'What if I receive a damaged or wrong item?', a: 'Contact us within 7 days with photos or an unboxing video, and we\'ll resolve it quickly.'
          },
          { q: 'How can I contact customer support?', a: 'Raise a ticket from this Chat Support or use the Contact Us page.' }
        ],
        '✨ Care & Usage': [
          { q: 'How do I wear or use the product?', a: 'Simple usage steps are included with each item or shared on the product page.' },
          { q: 'How do I care for and recharge my beads/crystals?', a: 'Keep them clean, avoid harsh chemicals/water exposure, and recharge regularly using sunlight, moonlight, or a selenite plate.' },
          { q: 'Do these products guarantee results?', a: 'These are spiritual tools meant to support your journey; experiences vary by person and results are not guaranteed.' }
        ]
      };
      let faqHtml = ''; Object.entries(faqs).forEach(([category, items]) => { faqHtml += `<div class="sth-faq-category" style="margin-bottom:20px;"><h4 style="margin:0 0 12px; font-weight:700; color:var(--sth-primary); font-size:13px; text-transform:uppercase; letter-spacing:0.5px;">${category}</h4>`; items.forEach((item, idx) => { const id = category.replace(/[^a-zA-Z0-9]/g, '') + idx; faqHtml += `<div class="sth-faq-item" id="faq-${id}"><div class="sth-faq-question" onclick="window.sthToggleFaq('${id}')">${item.q} <span class="toggle" style="color:var(--sth-primary); transition:transform 0.2s;">+</span></div><div class="sth-faq-answer">${item.a}</div></div>`; }); faqHtml += `</div>`; });
      return `<div class="sth-back" onclick="window.sthGoTo('menu')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Menu</div><div class="sth-content" style="background:#f8fafc;"><div class="sth-message bot" style="margin-bottom:24px;"><p>Here are answers to some common questions.</p></div><div style="padding-bottom:20px;">${faqHtml}</div><div style="text-align:center; margin-top:10px; padding:24px; background:white; border-radius:16px; box-shadow:0 4px 6px -1px rgba(0,0,0,0.02); border:1px solid #e2e8f0;"><p style="font-size:15px; font-weight:700; margin-bottom:4px; color:var(--sth-text);">Still need help?</p><p style="font-size:13px; color:var(--sth-text-muted); margin-top:0; margin-bottom:16px;">We're here for you.</p><button class="sth-btn" onclick="window.sthGoTo('create-ticket', 'other')">Contact Support</button></div><div style="height:20px;"></div></div>`;
    }

    function renderCreateTicket() {
      const isIssue = state.ticketType === 'issue';
      const filesHtml = state.files.map((f, i) => `<div class="sth-file-preview-item"><img src="${URL.createObjectURL(f)}" /><button class="sth-file-remove" onclick="window.sthRemoveFile(${i})">✕</button></div>`).join('');

      // draft values or defaults
      const emailVal = state.draftEmail !== undefined ? state.draftEmail : (state.user?.email || '');
      const subjectVal = state.draftSubject !== undefined ? state.draftSubject : '';
      const descVal = state.draftDescription !== undefined ? state.draftDescription : '';

      if (state.loading) {
        return `
            <div class="sth-content" style="display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center;">
                <div style="font-size: 40px; margin-bottom: 20px; animation: spin 1s linear infinite;">⏳</div>
                <h3 style="margin:0 0 8px; color:var(--sth-text);">Submitting ticket...</h3>
                <p style="color:var(--sth-text-muted);">Please wait a moment.</p>
            </div>
        `;
      }

      return `
      <div class="sth-back" onclick="window.sthGoTo('menu')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        Back
      </div>
      <div class="sth-content">
        <h3 style="margin: 0 0 16px; font-size: 20px; font-weight: 700;">${isIssue ? 'Report Issue' : 'New Request'}</h3>
        
        <div class="sth-form-embedded" style="background:white; box-shadow:none; border: none; padding: 0; margin: 0;">
          ${state.error ? `<div style="background:#fef2f2; color:#b91c1c; padding:12px; border-radius:8px; font-size:13px; margin-bottom:16px; display:flex; align-items:center; gap:8px;">⚠️ ${state.error}</div>` : ''}
          
          <div class="sth-input-group">
            <label class="sth-label required">Email Address</label>
            <input type="email" class="sth-input" id="sth-email" placeholder="name@example.com" value="${emailVal}" oninput="window.sthUpdateDraft('draftEmail', this.value)" />
          </div>
          
          <div class="sth-input-group">
            <label class="sth-label">Subject</label>
            <input type="text" class="sth-input" id="sth-subject" placeholder="${isIssue ? 'e.g., Damaged item' : 'Briefly describe your request'}" value="${subjectVal}" oninput="window.sthUpdateDraft('draftSubject', this.value)" />
          </div>
          
          <div class="sth-input-group">
            <label class="sth-label required">Description</label>
            <textarea class="sth-textarea" id="sth-description" placeholder="Please provide details..." oninput="window.sthUpdateDraft('draftDescription', this.value)">${descVal}</textarea>
          </div>
          
          <div class="sth-input-group">
            <label class="sth-label">Attachments</label>
            <div class="sth-file-upload" onclick="document.getElementById('sth-files').click()" style="padding: 16px; border-style: solid; border-width: 1px; border-color: var(--sth-border-color); background: #fff;">
              <div style="display:flex; align-items:center; gap: 12px; width: 100%;">
                 <span style="font-size:20px; color:#cbd5e1;">📎</span>
                 <div style="text-align:left; flex: 1;">
                   <div style="font-size:14px; font-weight:600; color:var(--sth-text);">Add Photos</div>
                 </div>
                 <span style="font-size: 20px; color: var(--sth-primary);">+</span>
              </div>
            </div>
            <input type="file" id="sth-files" accept="image/*,video/*" multiple onchange="window.sthHandleFiles(this)" style="display:none;" />
            <div class="sth-file-preview">${filesHtml}</div>
          </div>
          
          <div style="height: 24px;"></div>
          <button class="sth-btn" onclick="window.sthCreateTicket()">Submit Ticket</button>
        </div>
        <div style="height: 40px;"></div>
      </div>`;
    }

    function renderMyTickets() {
      if (state.loading) return `<div class="sth-back" onclick="window.sthGoTo('menu')">Menu</div><div class="sth-content">Loading...</div>`;
      let ticketsHtml = state.tickets.length === 0 ? `<div style="text-align:center; padding:40px; color:#999;">No tickets found.</div>` : state.tickets.map(t => {
        const isOpen = t.status === 'open' || t.status === 'new';
        return `<div class="sth-ticket-card" onclick="window.sthViewTicket('${t.id}')"><div style="display:flex; justify-content:space-between; margin-bottom:6px;"><span style="font-size:12px; color:#888;">#${t.id}</span><span style="font-size:10px; background:${isOpen ? '#e0f2fe' : '#f3f4f6'}; color:${isOpen ? '#0284c7' : '#6b7280'}; padding:2px 8px; border-radius:10px; font-weight:700; text-transform:uppercase;">${t.status}</span></div><div style="font-weight:600; font-size:14px; margin-bottom:4px;">${t.subject}</div><div style="font-size:12px; color:#555; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${t.description}</div></div>`;
      }).join('');
      return `<div class="sth-back" onclick="window.sthGoTo('menu')">Menu</div><div class="sth-content"><div class="sth-message bot"><p>Here are your support tickets:</p></div>${ticketsHtml}</div>`;
    }

    function toEpochMs(value) {
      if (!value) return Number.NaN;
      const parsed = new Date(value).getTime();
      return Number.isFinite(parsed) ? parsed : Number.NaN;
    }

    function getAttachmentKey(attachment, idx) {
      if (!attachment) return `attachment-${idx}`;
      if (attachment.id) return String(attachment.id);
      const path = String(attachment.path || attachment.url || '');
      const filename = String(attachment.filename || attachment.name || '');
      const createdAt = String(attachment.createdAt || '');
      return `${path}|${filename}|${createdAt}|${idx}`;
    }

    function inferAttachmentSender(attachment, messages, fallbackLastResponseBy) {
      const attachmentTime = toEpochMs(attachment && attachment.createdAt);
      let closestSender = '';
      let smallestDiff = Number.POSITIVE_INFINITY;

      for (let i = 0; i < messages.length; i += 1) {
        const message = messages[i];
        if (!message || !message.sender) continue;
        const messageTime = toEpochMs(message.createdAt);
        if (Number.isNaN(attachmentTime) || Number.isNaN(messageTime)) continue;
        const diff = Math.abs(messageTime - attachmentTime);
        if (diff <= 5 * 60 * 1000 && diff < smallestDiff) {
          smallestDiff = diff;
          closestSender = message.sender;
        }
      }

      if (closestSender) return closestSender;
      if (fallbackLastResponseBy === 'ADMIN') return 'ADMIN';
      if (fallbackLastResponseBy === 'USER') return 'USER';
      return 'USER';
    }

    function mergeTicketAttachmentsIntoMessages(messages, attachments, fallbackLastResponseBy) {
      const mergedMessages = messages.map((message, index) => ({
        ...message,
        id: message.id || `msg-${index}`,
        attachments: Array.isArray(message.attachments) ? [...message.attachments] : []
      }));

      const existingAttachmentKeys = new Set();
      for (let i = 0; i < mergedMessages.length; i += 1) {
        const messageAttachments = mergedMessages[i].attachments || [];
        for (let j = 0; j < messageAttachments.length; j += 1) {
          existingAttachmentKeys.add(getAttachmentKey(messageAttachments[j], j));
        }
      }

      const ticketAttachments = Array.isArray(attachments) ? attachments : [];
      ticketAttachments.forEach((attachment, idx) => {
        if (!attachment) return;
        const attachmentKey = getAttachmentKey(attachment, idx);
        if (existingAttachmentKeys.has(attachmentKey)) return;
        existingAttachmentKeys.add(attachmentKey);

        const attachmentTime = toEpochMs(attachment.createdAt);
        let closestIdx = -1;
        let smallestDiff = Number.POSITIVE_INFINITY;

        for (let i = 0; i < mergedMessages.length; i += 1) {
          const message = mergedMessages[i];
          const messageTime = toEpochMs(message.createdAt);
          if (Number.isNaN(attachmentTime) || Number.isNaN(messageTime)) continue;
          const diff = Math.abs(messageTime - attachmentTime);
          if (diff <= 5 * 60 * 1000 && diff < smallestDiff) {
            smallestDiff = diff;
            closestIdx = i;
          }
        }

        if (closestIdx >= 0) {
          mergedMessages[closestIdx].attachments.push(attachment);
          return;
        }

        mergedMessages.push({
          id: `attachment-message-${attachmentKey}`,
          sender: inferAttachmentSender(attachment, mergedMessages, fallbackLastResponseBy),
          content: '',
          attachments: [attachment],
          createdAt: attachment.createdAt || new Date().toISOString(),
          isSyntheticAttachment: true
        });
      });

      mergedMessages.sort((a, b) => {
        const aTime = toEpochMs(a.createdAt);
        const bTime = toEpochMs(b.createdAt);
        if (!Number.isNaN(aTime) && !Number.isNaN(bTime)) return aTime - bTime;
        if (!Number.isNaN(aTime)) return -1;
        if (!Number.isNaN(bTime)) return 1;
        return 0;
      });

      return mergedMessages;
    }

    function renderTicketDetail() {
      const t = state.currentTicket; if (!t) return renderMyTickets();

      // Timestamp helper
      const formatMsgTime = (d) => {
        if (!d) return '';
        const date = new Date(d);
        // "Feb 5, 10:30 PM"
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ', ' +
          date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
      };

      // Construct Unified Message List (Description + Messages)
      let allMessages = [];

      // 1. Initial Description (simulate as message)
      if (t.description) {
        allMessages.push({
          id: `ticket-${t.id}-initial`,
          sender: 'USER',
          content: t.description,
          attachments: [],
          createdAt: t.createdAt,
          isInitial: true
        });
      }

      // 2. Replies
      if (t.messages && t.messages.length) {
        allMessages = allMessages.concat(t.messages.map((m, idx) => ({
          ...m,
          id: m.id || `ticket-${t.id}-reply-${idx}`,
          attachments: Array.isArray(m.attachments) ? m.attachments : []
        })));
      }

      allMessages = mergeTicketAttachmentsIntoMessages(allMessages, t.attachments, t.lastResponseBy);

      const msgHtml = allMessages.map(m => {
        const isMe = m.sender === 'USER';
        const hasText = typeof m.content === 'string' && m.content.trim().length > 0;

        // Render attachments inline
        let attachHtml = '';
        if (m.attachments && m.attachments.length > 0) {
          attachHtml = `<div style="display:flex; gap:6px; flex-wrap:wrap; margin-top:10px; justify-content:${isMe ? 'flex-end' : 'flex-start'};">
                ${m.attachments.map(a => {
            const rawPath = String((a && (a.path || a.url)) || '');
            const hasAbsolutePath = rawPath.startsWith('http') || rawPath.startsWith('blob:') || rawPath.startsWith('data:');
            const url = hasAbsolutePath ? rawPath : (rawPath ? API_BASE + rawPath : '');
            const extRegex = /\.(jpg|jpeg|png|gif|webp|svg|bmp)$/i;
            const normalizedFilename = String((a && (a.filename || a.name)) || '');
            const isImg = (a.mimetype && a.mimetype.startsWith('image/')) || extRegex.test(rawPath) || extRegex.test(normalizedFilename);

            if (isImg) {
              if (!url) return '';
              return `<a href="${url}" target="_blank"><img src="${url}" style="max-width:100%; max-height:200px; object-fit:cover; border-radius:8px; display:block;" onerror="this.style.display='none'"></a>`;
            }
            if (!url) {
              return `<span style="display:flex; align-items:center; gap:6px; padding:6px 10px; background:rgba(255,255,255,0.9); border-radius:8px; color:${isMe ? '#0f172a' : '#334155'}; font-size:12px; font-weight:500;">📎 ${normalizedFilename || 'Attachment'}</span>`;
            }
            return `<a href="${url}" target="_blank" style="display:flex; align-items:center; gap:6px; padding:6px 10px; background:rgba(255,255,255,0.9); border-radius:8px; text-decoration:none; color:${isMe ? '#0f172a' : '#334155'}; font-size:12px; font-weight:500;">📎 ${normalizedFilename || 'Attachment'}</a>`;
          }).join('')}
             </div>`;
        }

        return `
          <div style="display:flex; flex-direction:column; margin-bottom:20px;">
            <div style="display:flex; justify-content:${isMe ? 'flex-end' : 'flex-start'}; align-items:flex-end; gap:8px;">
                ${!isMe ? `<div style="width:28px; height:28px; background:var(--sth-primary); border-radius:50%; display:flex; align-items:center; justify-content:center; color:white; font-size:10px; flex-shrink:0; font-weight:700;">ST</div>` : ''}
                <div style="display:flex; flex-direction:column; align-items:${isMe ? 'flex-end' : 'flex-start'}; max-width:85%;">
                    <div style="padding:${hasText ? '12px 16px' : '8px'}; border-radius:18px; background:${isMe ? 'var(--sth-accent)' : 'white'}; color:${isMe ? 'white' : 'var(--sth-text)'}; font-size:14px; line-height:1.5; box-shadow:${isMe ? '0 4px 12px rgba(15,23,42,0.1)' : '0 2px 4px rgba(0,0,0,0.02)'}; border:${isMe ? 'none' : '1px solid var(--sth-border-color)'}; border-bottom-${isMe ? 'right' : 'left'}-radius:4px;">
                    ${hasText ? `<div>${m.content}</div>` : ''}
                    ${attachHtml}
                    </div>
                    <div style="font-size:10px; color:#94a3b8; margin-top:4px; padding:0 4px; font-weight:500;">${formatMsgTime(m.createdAt)}</div>
                </div>
            </div>
          </div>`;
      }).join('');

      const badge = t.status === 'open' || t.status === 'new' ?
        `<span style="font-size:10px; background:#dbeafe; color:#1d4ed8; padding:3px 8px; border-radius:12px; font-weight:700; text-transform:uppercase; letter-spacing:0.5px;">${t.status}</span>` :
        `<span style="font-size:10px; background:#f1f5f9; color:#64748b; padding:3px 8px; border-radius:12px; font-weight:700; text-transform:uppercase; letter-spacing:0.5px;">${t.status}</span>`;

      return `
        <div class="sth-back" onclick="window.sthGoTo('my-tickets')" style="padding: 10px 24px;">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          Back to Tickets
        </div>
        <div class="sth-content" style="display:flex; flex-direction:column; height:calc(100% - 44px); padding:0; background:#f8fafc;">
          <div style="padding:10px 16px; background:white; border-bottom:1px solid #e2e8f0; flex-shrink:0; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
             <div style="font-weight:700; font-size:15px; margin-bottom:4px; line-height:1.4;">${t.subject}</div>
             <div style="display:flex; justify-content:space-between; align-items:center;">
                <span style="font-size:11px; color:#64748b;">#${t.id}</span>
                ${badge}
             </div>
          </div>
          
          <div style="flex:1; overflow-y:auto; padding:20px; display:flex; flex-direction:column;">
             ${msgHtml.length ? msgHtml : '<div style="text-align:center; color:#94a3b8; font-size:13px; margin-top:30px;">No messages yet.</div>'}
          </div>
          ${t.status !== 'closed' ? `
             <div style="background:white; border-top:1px solid #e2e8f0; padding:12px;">
                
                <!-- Preview Area -->
                <div id="sth-reply-preview" style="display:none; gap:8px; padding-bottom:12px; overflow-x:auto;"></div>

                <div style="display:flex; gap:10px; align-items:center;">
                   <label for="sth-reply-file" style="cursor:pointer; padding: 8px; border-radius: 50%; color: #64748b; transition: background 0.2s;">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
                   </label>
                   <input type="file" id="sth-reply-file" multiple style="display:none;" onchange="window.sthHandleReplyFiles(this)">
                   
                   <input type="text" id="sth-reply-input" class="sth-input" placeholder="Type a reply..." style="border-radius:24px; font-size:14px; background:#f8fafc; border:none; padding: 12px 16px;">
               <button class="sth-btn" onclick="window.sthReplyTicket()" style="width:48px; height:48px; border-radius:50%; padding:0; display:flex; align-items:center; justify-content:center; background:var(--sth-primary); flex-shrink:0;">
                 <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
               </button>
            </div>` :
          '<div style="text-align:center; padding:20px; color:#64748b; font-size:13px; background:#f1f5f9; border-top:1px solid #e2e8f0;">This ticket has been closed.</div>'}
        </div>`;
    }

    function renderSuccess() {
      return `
        <div class="sth-content" style="text-align:center; display:flex; flex-direction:column; align-items:center; justify-content: center; height: 100%;">
          <div style="width:80px; height:80px; background:#f0fdf4; color:#16a34a; border-radius:50%; display:flex; align-items:center; justify-content:center; margin-bottom:24px; position:relative;">
             <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="animation:sth-fade-in 0.5s ease-out;"><polyline points="20 6 9 17 4 12"></polyline></svg>
          </div>
          <h2 style="font-size:22px; font-weight:800; margin-bottom:12px; color:var(--sth-text);">Ticket Created!</h2>
          <p style="color:var(--sth-text-muted); max-width:260px; margin:0 auto 32px; font-size: 15px; line-height:1.5;">${state.successMessage}</p>
          <button class="sth-btn" onclick="window.sthGoTo('menu')" style="max-width:240px;">Return to Menu</button>
        </div>
      `;
    }

    // --- Interaction Handlers ---

    window.sthToggleChat = () => { state.isOpen = !state.isOpen; render(); };
    window.sthGoTo = (v, e) => { state.view = v; state.error = ''; if (e) state.ticketType = e; render(); };
    window.sthHandleFiles = (inp) => { state.files = [...state.files, ...Array.from(inp.files)].slice(0, 5); render(); };
    window.sthRemoveFile = (i) => { state.files.splice(i, 1); render(); };
    window.sthUpdateDraft = (k, v) => { state[k] = v; };

    window.sthLogout = () => {
      state.user = null;
      state.view = 'login';
      state.tickets = [];
      state.orders = [];
      state.ordersFetchedAt = 0;
      localStorage.removeItem('sth_chat_state');
      render();
    };

    window.sthViewTicket = async (id) => {
      state.loading = true; render();
      try {
        const authQuery = getTicketAuthQuery();
        const res = await fetch(API_BASE + `/api/tickets/${id}${authQuery}`, { cache: 'no-store' });
        const data = await res.json();
        if (data.ticket) { state.currentTicket = data.ticket; state.view = 'ticket-detail'; }
      } catch (e) { }
      state.loading = false; render();
    };

    window.sthToggleFaq = (id) => {
      const el = document.getElementById('faq-' + id);
      if (el) {
        const isActive = el.classList.contains('active');
        // document.querySelectorAll('.sth-faq-item').forEach(i => i.classList.remove('active')); // Close others?
        if (!isActive) el.classList.add('active');
        else el.classList.remove('active');
      }
    };

    window.sthSendOTP = async () => {
      let phoneVal = document.getElementById('sth-phone').value || '';
      phoneVal = phoneVal.replace(/\D/g, '');
      if (phoneVal.length === 12 && phoneVal.startsWith('91')) phoneVal = phoneVal.substring(2);
      state.loading = true; state.phone = phoneVal; render();
      try {
        const res = await fetch(API_BASE + '/api/auth/send-otp', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone: phoneVal }) });
        const data = await res.json();
        if (data.success) { state.view = 'verify'; } else state.error = data.error;
      } catch (e) { state.error = "Connection Error"; }
      state.loading = false; render();
    };

    window.sthVerifyOTP = async () => {
      const otpVal = document.getElementById('sth-otp').value || '';
      state.loading = true; state.otp = otpVal; render();
      try {
        const res = await fetch(API_BASE + '/api/auth/verify-otp', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone: state.phone, code: otpVal }) });
        const data = await res.json();
        if (data.success) {
          const verifiedUser = data.user || {};
          const existingShopifyFirstName = getCurrentShopifyFirstName();
          state.user = {
            ...(state.user || {}),
            id: verifiedUser.id || state.user?.id,
            phone: verifiedUser.phone || state.phone || state.user?.phone || '',
            email: verifiedUser.email || state.user?.email || '',
            shopifyFirstName: existingShopifyFirstName || '',
            shopify_first_name: existingShopifyFirstName || '',
            firstName: existingShopifyFirstName || '',
            first_name: existingShopifyFirstName || '',
            name: existingShopifyFirstName || '',
            nameSource: existingShopifyFirstName ? 'shopify' : (state.user?.nameSource || '')
          };
          state.otp = '';
          saveState();
          state.view = 'menu';
          window.sthLoadTickets();
          prefetchOrders(true);
        } else state.error = data.error || 'Invalid Code';
      } catch (e) { state.error = "Connection Error"; }
      state.loading = false; render();
    };

    window.sthLoadTickets = async () => {
      if (!state.user) return;
      try {
        const authQuery = getTicketAuthQuery();
        if (!authQuery) return;
        const res = await fetch(API_BASE + `/api/tickets${authQuery}`, { cache: 'no-store' });
        const data = await res.json();
        state.tickets = data.tickets || [];
        if (looksLikeBackendUserId(data.userId) && state.user.id !== data.userId) {
          state.user.id = data.userId;
          saveState();
        }
        render();
      } catch (e) { }
    };
    window.sthLoadOrders = async () => {
      state.ticketType = 'tracking';
      state.view = 'orders';
      state.loading = !hasFreshOrders();
      render();
      try {
        await fetchOrdersByPhone(false);
      } catch (e) { }
      state.loading = false;
      render();
    };

    window.sthSelectOrder = (num) => { state.selectedOrder = state.orders.find(o => o.orderNumber === num); if (state.ticketType === 'issue') { state.view = 'select-issue'; } else { state.view = 'order-detail'; } render(); };

    window.sthCreateTicket = async () => {
      const sub = document.getElementById('sth-subject').value;
      const desc = document.getElementById('sth-description').value;
      const email = document.getElementById('sth-email').value;

      if (!email || !/\S+@\S+\.\S+/.test(email)) { state.error = 'Please enter a valid email address.'; render(); return; }
      if (!sub || !desc) { state.error = 'Please fill all fields.'; render(); return; }

      state.loading = true; render();

      const formData = new FormData();
      if (state.user?.id) formData.append('userId', state.user.id);
      formData.append('phone', getNormalizedPhone(state.user?.phone || state.phone));
      formData.append('userEmail', email);
      formData.append('subject', sub);
      formData.append('description', desc);
      formData.append('ticketType', state.ticketType);

      if (state.selectedOrder) {
        formData.append('orderNumber', state.selectedOrder.orderNumber);
        formData.append('orderDetails', JSON.stringify(state.selectedOrder));
      }
      if (state.selectedProducts.length) {
        formData.append('selectedProducts', JSON.stringify(state.selectedProducts));
      }
      state.files.forEach(f => formData.append('attachments', f));

      try {
        const res = await fetch(API_BASE + '/api/tickets', { method: 'POST', body: formData });
        const data = await res.json();
        if (data.success) {
          if (looksLikeBackendUserId(data.userId)) {
            state.user = { ...(state.user || {}), id: data.userId };
            saveState();
          }
          state.successMessage = `Your ticket <b>#${data.ticket.id}</b> has been created. Updates will be sent to ${email}.`;
          state.view = 'success';
          // Clear state
          state.files = [];
          state.selectedProducts = [];
          state.selectedOrder = null;
          state.draftSubject = '';
          state.draftDescription = '';
          // email intentionally kept in draft for convenience? No, clear it or keep it.
          // Keep email as it might be user's pref.

          if (window.sthLoadTickets) window.sthLoadTickets();
        } else {
          if (data.error === 'User not found') {
            // Session invalid (stale ID)
            alert('Your session has expired. Please login again.');
            window.sthLogout();
            return;
          }
          state.error = data.error;
        }
      } catch (e) {
        state.error = "Connection failed. Please try again.";
      }
      state.loading = false; render();
    };
    // Handle reply files preview
    window.sthHandleReplyFiles = (inp) => {
      const files = Array.from(inp.files);
      const preview = document.getElementById('sth-reply-preview');
      if (files.length > 0) {
        preview.style.display = 'flex';
        preview.innerHTML = files.map(f => `
                <div style="position:relative; width:48px; height:48px; border-radius:8px; overflow:hidden; border:1px solid #e2e8f0; flex-shrink:0;">
                    ${f.type.startsWith('image/') ? `<img src="${URL.createObjectURL(f)}" style="width:100%; height:100%; object-fit:cover;">` : '<div style="width:100%; height:100%; background:#f1f5f9; display:flex; align-items:center; justify-content:center; font-size:20px;">📄</div>'}
                </div>
            `).join('');
      } else {
        preview.style.display = 'none';
      }
    };

    window.sthReplyTicket = async () => {
      const content = document.getElementById('sth-reply-input').value;
      const fileInput = document.getElementById('sth-reply-file');
      const files = fileInput ? Array.from(fileInput.files) : [];

      if (!content && files.length === 0) return;

      const ticketId = state.currentTicket.id;

      // Generate optimistic attachments
      const optimisticAttachments = files.map(f => ({
        path: URL.createObjectURL(f),
        filename: f.name,
        mimetype: f.type
      }));

      // Optimistic UI update
      state.currentTicket.messages.push({
        sender: 'USER',
        content: content,
        attachments: optimisticAttachments.length ? optimisticAttachments : null,
        createdAt: new Date().toISOString()
      });

      // Clear inputs
      document.getElementById('sth-reply-input').value = '';
      if (fileInput) {
        fileInput.value = '';
        const preview = document.getElementById('sth-reply-preview');
        if (preview) {
          preview.style.display = 'none';
          preview.innerHTML = '';
        }
      }

      // Scroll to bottom
      const scrollContainer = document.querySelector('.sth-content > div[style*="overflow-y:auto"]');
      if (scrollContainer) scrollContainer.scrollTop = scrollContainer.scrollHeight;
      render();

      try {
        const formData = new FormData();
        formData.append('message', content);
        if (state.user?.id) formData.append('userId', state.user.id);
        formData.append('phone', getNormalizedPhone(state.user?.phone || state.phone));

        for (let i = 0; i < files.length; i++) {
          formData.append('attachments', files[i]);
        }

        const res = await fetch(API_BASE + `/api/tickets/${ticketId}/customer-reply`, {
          method: 'POST',
          body: formData
        });

        if (!res.ok) throw new Error('Failed to send');

        // Refresh to show actual message/attachments from server
        // We delay slightly to allow server processing/upload
        setTimeout(() => window.sthViewTicket(ticketId), 1000);

      } catch (e) {
        console.error(e);
        alert('Failed to send reply. Please try again.');
      }
    };

    window.sthStartIssueFlow = async () => {
      state.view = 'select-order';
      state.ticketType = 'issue';
      state.ordersLoading = !hasFreshOrders();
      render();
      try {
        await fetchOrdersByPhone(false);
      } catch (e) {
        state.error = "Failed to load orders.";
      }
      state.ordersLoading = false;
      render();
    };
    window.sthSelectOrderForIssue = (num) => { const order = state.orders.find(o => o.orderNumber === num); if (!order) return; state.selectedOrder = order; const isDelivered = (order.deliveryStatus || '').toLowerCase() === 'delivered'; if (!isDelivered) { state.error = `Order ${num} must be Delivered to report issue. <span style="text-decoration:underline; cursor:pointer;" onclick="window.sthForceSelectOrder('${num}')">Continue anyway</span>`; render(); return; } state.view = 'select-issue'; state.error = ''; render(); };
    window.sthForceSelectOrder = (num) => { const order = state.orders.find(o => o.orderNumber === num); if (order) { state.selectedOrder = order; state.view = 'select-issue'; state.error = ''; render(); } };
    window.sthSelectIssue = (id) => { state.selectedIssue = id; state.selectedProducts = []; state.view = 'select-products'; render(); };
    window.sthToggleProduct = (idx) => { const item = state.selectedOrder.lineItems[idx]; const exists = state.selectedProducts.find(p => p.id === item.id); if (exists) state.selectedProducts = state.selectedProducts.filter(p => p.id !== item.id); else state.selectedProducts.push(item); render(); };
    window.sthSubmitIssue = () => { if (state.selectedProducts.length === 0) { state.error = "Select at least one product."; render(); return; } state.view = 'create-ticket'; state.error = ''; render(); };

    // --- Initialization ---
    loadState();

    // Shopify context should override stale local values.
    if (config.user && (config.user.id || config.user.email || config.user.phone || config.user.firstName || config.user.first_name || config.user.name)) {
      console.log('Soultheory Chat - User Context:', config.user);
      const firstName = extractFirstName(config.user.firstName || config.user.first_name || config.user.name);
      const persistedBackendUserId = looksLikeBackendUserId(state.user?.id) ? String(state.user.id).trim() : '';
      const normalizedPhone = getNormalizedPhone(state.user?.phone || config.user.phone || state.phone);
      state.user = {
        ...(state.user || {}),
        id: persistedBackendUserId || '',
        shopifyCustomerId: config.user.id ? String(config.user.id) : (state.user?.shopifyCustomerId || ''),
        email: config.user.email || state.user?.email || '',
        phone: normalizedPhone || state.user?.phone || '',
        shopifyFirstName: firstName || state.user?.shopifyFirstName || '',
        shopify_first_name: firstName || state.user?.shopify_first_name || '',
        firstName: firstName || state.user?.firstName || '',
        first_name: firstName || state.user?.first_name || '',
        name: firstName || state.user?.name || '',
        nameSource: firstName ? 'shopify' : (state.user?.nameSource || '')
      };
      if (!state.phone && state.user.phone) state.phone = state.user.phone;
      saveState();
    }

    if (state.user) {
      window.sthLoadTickets();
      prefetchOrders(false);
    }
    render();
  }
})();
